/*
 * Automatically forwards `completion_source` query param across all vault
 * funnel step navigations so it is never dropped between steps.
 *
 * Runs only on the client — server-side rendering does not need this.
 */
export default defineNuxtPlugin(({ $router }) => {
  $router.beforeEach((to, from) => {
    const isVaultFunnel = to.path.includes('/dashboard/vault/') && to.path.includes('/form/')
    const sourceValue = from.query?.completion_source

    if (isVaultFunnel && sourceValue && !to.query?.completion_source) {
      return { ...to, query: { ...to.query, completion_source: sourceValue } }
    }
  })
})

